window.__webpack_nonce__ = window.NONCE_ID
